<div *ngIf="user_logged">
  <div class="header">
    <div class="header-cont">
      <h2>{{ 'new_poi.title' | translate }}</h2>
    </div>
  </div>

  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'new_poi.sections.name' | translate }}</h4>
    </div>
  </div>

  <div class="single-section">
    <div class="section-cont">
      <mat-tab-group>
        <mat-tab label="Italiano">
          <mat-form-field class="section-input">
            <mat-label>{{ 'new_poi.sections.name' | translate }}</mat-label>
            <input matInput maxlength="255" type="text" [(ngModel)]="poi_current.poi_name.it" required>
          </mat-form-field>
        </mat-tab>
        <mat-tab label="Slovenščina">
          <mat-form-field class="section-input">
            <mat-label>{{ 'new_poi.sections.name' | translate }}</mat-label>
            <input matInput maxlength="255" type="text" [(ngModel)]="poi_current.poi_name.sl" required>
          </mat-form-field>
        </mat-tab>
        <mat-tab label="English">
          <mat-form-field class="section-input">
            <mat-label>{{ 'new_poi.sections.name' | translate }}</mat-label>
            <input matInput maxlength="255" type="text" [(ngModel)]="poi_current.poi_name.en" required>
          </mat-form-field>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>

  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'new_poi.sections.address' | translate }}</h4>
    </div>
  </div>

  <div class="single-section">
    <div class="section-cont">
      <mat-form-field class="section-input">
        <mat-label>{{ 'new_poi.sections.address' | translate }}</mat-label>
        <input matInput maxlength="255" type="text" [(ngModel)]="poi_current.address" required>
      </mat-form-field>
    </div>
  </div>

  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'new_poi.sections.coords.title' | translate }}</h4>
    </div>
  </div>

  <div class="single-section">
    <div class="section-cont">
      <mat-form-field class="section-input">
        <mat-label>{{ 'new_poi.sections.coords.lat' | translate }}</mat-label>
        <input matInput type="number" [(ngModel)]="poi_current.coords.lat" required (change)="updateCoords()">
      </mat-form-field>
      <mat-form-field class="section-input">
        <mat-label>{{ 'new_poi.sections.coords.lon' | translate }}</mat-label>
        <input matInput type="number" [(ngModel)]="poi_current.coords.lon" required (change)="updateCoords()">
      </mat-form-field>
    </div>
  </div>

  <div class="single-section">
    <div class="section-cont">
      <div #map class="map"></div>
    </div>
  </div>

  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'new_poi.sections.short_descr' | translate }}</h4>
    </div>
  </div>

  <div class="single-section">
    <div class="section-cont">
      <mat-tab-group>
        <mat-tab label="Italiano">
          <mat-form-field class="section-input">
            <mat-label>{{ 'new_poi.sections.short_descr' | translate }}</mat-label>
            <textarea matInput maxlength="385" [(ngModel)]="poi_current.short_descr.it" required></textarea>
          </mat-form-field>
        </mat-tab>
        <mat-tab label="Slovenščina">
          <mat-form-field class="section-input">
            <mat-label>{{ 'new_poi.sections.short_descr' | translate }}</mat-label>
            <textarea matInput maxlength="385" [(ngModel)]="poi_current.short_descr.sl" required></textarea>
          </mat-form-field>
        </mat-tab>
        <mat-tab label="English">
          <mat-form-field class="section-input">
            <mat-label>{{ 'new_poi.sections.short_descr' | translate }}</mat-label>
            <textarea matInput maxlength="385" [(ngModel)]="poi_current.short_descr.en" required></textarea>
          </mat-form-field>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>

  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'new_poi.sections.descr' | translate }}</h4>
    </div>
  </div>

  <div class="single-section">
    <div class="section-cont">
      <mat-tab-group>
        <mat-tab label="Italiano">
          <mat-form-field class="section-input">
            <mat-label>{{ 'new_poi.sections.descr' | translate }}</mat-label>
            <textarea matInput [(ngModel)]="poi_current.description.it" required></textarea>
          </mat-form-field>
        </mat-tab>
        <mat-tab label="Slovenščina">
          <mat-form-field class="section-input">
            <mat-label>{{ 'new_poi.sections.descr' | translate }}</mat-label>
            <textarea matInput [(ngModel)]="poi_current.description.sl" required></textarea>
          </mat-form-field>
        </mat-tab>
        <mat-tab label="English">
          <mat-form-field class="section-input">
            <mat-label>{{ 'new_poi.sections.descr' | translate }}</mat-label>
            <textarea matInput [(ngModel)]="poi_current.description.en" required></textarea>
          </mat-form-field>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>

  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'new_poi.sections.trivia' | translate }}</h4>
    </div>
  </div>

  <div class="single-section">
    <div class="section-cont">
      <mat-tab-group>
        <mat-tab label="Italiano">
          <mat-form-field class="section-input">
            <mat-label>{{ 'new_poi.sections.trivia' | translate }}</mat-label>
            <textarea matInput [(ngModel)]="poi_current.trivia['it']" required></textarea>
          </mat-form-field>
        </mat-tab>
        <mat-tab label="Slovenščina">
          <mat-form-field class="section-input">
            <mat-label>{{ 'new_poi.sections.trivia' | translate }}</mat-label>
            <textarea matInput [(ngModel)]="poi_current.trivia['sl']" required></textarea>
          </mat-form-field>
        </mat-tab>
        <mat-tab label="English">
          <mat-form-field class="section-input">
            <mat-label>{{ 'new_poi.sections.trivia' | translate }}</mat-label>
            <textarea matInput [(ngModel)]="poi_current.trivia['en']" required></textarea>
          </mat-form-field>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>

  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'admin_single_itin.sections.themes' | translate }}</h4>
    </div>
  </div>

  <div class="single-section">
    <div class="section-cont">
      <mat-selection-list #themesSelection (selectionChange)="themesSelectionFunction()">
        <mat-list-option *ngFor="let theme of themes_list" color="primary" [value]="theme">
          <mat-icon matListIcon>explore</mat-icon>
          {{theme.name[current_lang]}}
        </mat-list-option>
      </mat-selection-list>
    </div>
  </div>

  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'admin_single_itin.sections.geopos' | translate }}</h4>
    </div>
  </div>

  <div class="single-section">
    <div class="section-cont">
      <mat-selection-list #geoposSelection (selectionChange)="geoposSelectionFunction()">
        <mat-list-option *ngFor="let geopos of geopos_list" color="primary" [selected]="checkGeopos(geopos)" [disabled]="!user_logged.isadmin || poi_current.geopos.length > 0" [value]="geopos">
          <mat-icon matListIcon>explore</mat-icon>
          {{geopos.name[current_lang]}}
        </mat-list-option>
      </mat-selection-list>
    </div>
  </div>

  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'single_itin.audio_icon' | translate }}</h4>
    </div>
  </div>

  <div class="single-section">
    <div class="section-cont">
      <ng-container *ngIf="checkAttachments(poi_current.attachments, 'audio'); else noAudioUploaded">
        <mat-selection-list #titleAudio (selectionChange)="titleAudioSelection()">
          <mat-list-option *ngFor="let audio of singleTypeAttachments(poi_current.attachments, 'audio')" color="primary" [disabled]="titleAudioDisabled()" [value]="audio">
            <mat-icon matListIcon>volume_up</mat-icon>
            <div class="option-text">
              <span class="file-name">{{audio.name}} - </span>
              <span class="source-text" [matTooltip]="audio.source" [matTooltipPosition]="'above'">{{audio.source}}</span>
            </div>
          </mat-list-option>
        </mat-selection-list>
      </ng-container>
      <ng-template #noAudioUploaded>
        <p class="no-attach">
          <span>{{ 'new_poi.no_audio' | translate }}</span>
        </p>
      </ng-template>
    </div>
  </div>

  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'single_itin.avatar' | translate }}</h4>
    </div>
  </div>

  <div class="single-section">
    <div class="section-cont">
      <ng-container *ngIf="checkAttachments(poi_current.attachments, 'avatar'); else noAvatarUploaded">
        <mat-selection-list #avatar (selectionChange)="attachmentSelectionFunction()">
          <mat-list-option *ngFor="let pic of singleTypeAttachments(poi_current.attachments, 'avatar')" color="primary" [value]="pic">
            <mat-icon matListIcon>add_to_photos</mat-icon>
            <div class="option-text">
              <span class="file-name">{{pic.name}} - </span>
              <span class="source-text" [matTooltip]="pic.source" [matTooltipPosition]="'above'">{{pic.source}}</span>
            </div>
          </mat-list-option>
        </mat-selection-list>
      </ng-container>
      <ng-template #noAvatarUploaded>
        <p class="no-attach">
          <span>{{ 'new_poi.no_pics' | translate }}</span>
        </p>
      </ng-template>
    </div>
  </div>

  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'new_poi.sections.pics' | translate }}</h4>
    </div>
  </div>

  <div class="single-section">
    <div class="section-cont">
      <ng-container *ngIf="checkAttachments(poi_current.attachments, 'picture'); else noPics">
        <mat-selection-list #picSelection (selectionChange)="attachmentSelectionFunction()">
          <mat-list-option *ngFor="let pic of singleTypeAttachments(poi_current.attachments, 'picture')" color="primary" [value]="pic">
            <mat-icon matListIcon>camera_alt</mat-icon>
            <div class="option-text">
              <span class="file-name">{{pic.name}} - </span>
              <span class="source-text" [matTooltip]="pic.source" [matTooltipPosition]="'above'">{{pic.source}}</span>
            </div>
          </mat-list-option>
        </mat-selection-list>
      </ng-container>
      <ng-template #noPics>
        <p class="no-attach">
          <span>{{ 'new_poi.no_pics' | translate }}</span>
        </p>
      </ng-template>
    </div>
  </div>

  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'admin_single_itin.sections.audio' | translate }}</h4>
    </div>
  </div>

  <div class="single-section">
    <div class="section-cont">
      <ng-container *ngIf="checkAttachments(poi_current.attachments, 'audio'); else noAudio">
        <mat-selection-list #audioSelection (selectionChange)="attachmentSelectionFunction()">
          <mat-list-option *ngFor="let audio of singleTypeAttachments(poi_current.attachments, 'audio')" color="primary" [value]="audio">
            <mat-icon matListIcon>volume_up</mat-icon>
            <div class="option-text">
              <span class="file-name">{{audio.name}} - </span>
              <span class="source-text" [matTooltip]="audio.source" [matTooltipPosition]="'above'">{{audio.source}}</span>
            </div>
          </mat-list-option>
        </mat-selection-list>
      </ng-container>
      <ng-template #noAudio>
        <p class="no-attach">
          <span>{{ 'new_poi.no_audio' | translate }}</span>
        </p>
      </ng-template>
    </div>
  </div>

  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'new_poi.sections.docs' | translate }}</h4>
    </div>
  </div>

  <div class="single-section">
    <div class="section-cont">
      <ng-container *ngIf="checkAttachments(poi_current.attachments, 'document'); else noDocs">
        <mat-selection-list #docSelection (selectionChange)="attachmentSelectionFunction()">
          <mat-list-option *ngFor="let doc of singleTypeAttachments(poi_current.attachments, 'document')" color="primary" [value]="doc">
            <mat-icon matListIcon>subject</mat-icon>
            <div class="option-text">
              <span class="file-name">{{doc.name}} - </span>
              <span class="source-text" [matTooltip]="doc.source" [matTooltipPosition]="'above'">{{doc.source}}</span>
            </div>
          </mat-list-option>
        </mat-selection-list>
      </ng-container>
      <ng-template #noDocs>
        <p class="no-attach">
          <span>{{ 'new_poi.no_docs' | translate }}</span>
        </p>
      </ng-template>
    </div>
  </div>

  <div class="section-headers">
    <div class="section-headers-cont">
      <h4>{{ 'new_poi.sections.video' | translate }}</h4>
    </div>
  </div>

  <div class="single-section">
    <div class="section-cont">
      <ng-container *ngIf="checkAttachments(poi_current.attachments, 'video'); else noVideo">
        <mat-selection-list #videoSelection (selectionChange)="attachmentSelectionFunction()">
          <mat-list-option *ngFor="let video of singleTypeAttachments(poi_current.attachments, 'video')" color="primary" [value]="video">
            <mat-icon matListIcon>movie</mat-icon>
            <div class="option-text">
              <span class="file-name">{{video.name}}</span>
              <span *ngIf="!!video.source" class="source-text" [matTooltip]="video.source" [matTooltipPosition]="'above'">- {{video.source}}</span>
            </div>
          </mat-list-option>
        </mat-selection-list>
      </ng-container>
      <ng-template #noVideo>
        <p class="no-attach">
          <span>{{ 'new_poi.no_video' | translate }}</span>
        </p>
      </ng-template>
    </div>
  </div>

  <div class="page-footer">
    <div class="page-footer-btns">
      <button mat-raised-button class="generic-btn" (click)="addAtt()">
        <mat-icon>attach_file</mat-icon>
      </button>
      <button mat-raised-button class="generic-btn" (click)="addVid()">
        <mat-icon>videocam</mat-icon>
      </button>
      <button mat-raised-button class="generic-btn" (click)="addAva()">
        <mat-icon>add_to_photos</mat-icon>
      </button>
      <button mat-raised-button class="remove-icon-btn" (click)="remAtt()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>

  <div class="page-footer">
    <div class="page-footer-btns">
      <button mat-raised-button class="save-icon-btn" (click)="savePoi()">
        <mat-icon>save</mat-icon>
      </button>
    </div>
  </div>
</div>

<app-loading-overlay [loading]="loading"></app-loading-overlay>
